import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { UserContext } from '@/components/App';
import CustomTags from '@/components/Account/CustomTags';
import TariffTable from '@/components/Account/TariffTable';
import useTariffBundle from '@/components/Account/hooks/useTariffBundle';
import { AccentBar, Card, Section, SectionHeader, SectionNote, SectionTitle } from '../blocks';

// Both panels are existing Account components reading the overridden context, so the tariffs
// and tags an admin edits here are the same rows the shipper sees on their own account.
const TariffsTags = () => {
    const { client } = useContext(UserContext);
    const { tariffs, overrides, driverMappings, callbacks } = useTariffBundle();

    return (
        <>
            <Section>
                <SectionHeader>
                    <AccentBar />
                    <SectionTitle>Agreed tariffs</SectionTitle>
                    <SectionNote>· corporate-only</SectionNote>
                </SectionHeader>
                <Card>
                    <div
                        css={css`
                            padding: 1.25rem;
                        `}
                    >
                        {/* `bare` — this Card is the surface; TariffTable must not add its own. */}
                        <TariffTable
                            client={client}
                            tariffs={tariffs}
                            overrides={overrides}
                            driverMappings={driverMappings}
                            callbacks={callbacks}
                            bare
                        />
                    </div>
                </Card>
            </Section>

            <Section>
                <SectionHeader>
                    <AccentBar />
                    <SectionTitle>Their uploads &amp; tags</SectionTitle>
                </SectionHeader>
                <Card>
                    <div
                        css={css`
                            padding: 1.25rem;
                        `}
                    >
                        {/* `bare` — this Card is the surface; CustomTags must not add its own. */}
                        <CustomTags bare />
                    </div>
                </Card>
            </Section>
        </>
    );
};

export default TariffsTags;
